import { ResourceStateDtoStatusEnum } from '@jooxter/api';
import { getThemeColorHex, TThemeColor } from '@jooxter/tailwind-config';
import { ResourceOccupationStatusEnum } from './resource-occupation-status.enum';
import { rgbToHex } from '../color';

export const GRADIENT_STOPS = [
  { pct: 0, color: 'primary100' as keyof TThemeColor },
  { pct: 15, color: 'primary60' as keyof TThemeColor },
  { pct: 45, color: 'primary40' as keyof TThemeColor },
  { pct: 60, color: 'red40' as keyof TThemeColor },
  { pct: 75, color: 'red60' as keyof TThemeColor },
  { pct: 100, color: 'red100' as keyof TThemeColor },
] as const;

const hexToRgb = (hex: string): [number, number, number] => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return [0, 0, 0];
  return [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)];
};

export const getStatusFill = (status: ResourceStateDtoStatusEnum | undefined) => {
  return status === ResourceStateDtoStatusEnum.Busy
    ? getThemeColorHex('red100')
    : status === ResourceStateDtoStatusEnum.Free
      ? getThemeColorHex('green100')
      : getThemeColorHex('neutral100');
};

export const getOccupationFill = (occupationStatus: ResourceOccupationStatusEnum | undefined) => {
  return occupationStatus === ResourceOccupationStatusEnum.Occupied
    ? getThemeColorHex('red100')
    : occupationStatus === ResourceOccupationStatusEnum.Unoccupied
      ? getThemeColorHex('green100')
      : getThemeColorHex('neutral100');
};

export const getHeatmapFill = (heatmapIntensity?: number) => {
  const intensity = Math.max(0, Math.min(100, heatmapIntensity ?? 0));

  const stops = GRADIENT_STOPS.map((s) => ({
    pct: s.pct,
    hex: getThemeColorHex(s.color),
  }));

  for (let i = 0; i < stops.length - 1; i++) {
    const lower = stops[i];
    const upper = stops[i + 1];

    if (intensity >= lower.pct && intensity <= upper.pct) {
      const t = (intensity - lower.pct) / (upper.pct - lower.pct);
      const lowerRgb = hexToRgb(lower.hex);
      const upperRgb = hexToRgb(upper.hex);
      const r = Math.round(lowerRgb[0] + (upperRgb[0] - lowerRgb[0]) * t);
      const g = Math.round(lowerRgb[1] + (upperRgb[1] - lowerRgb[1]) * t);
      const b = Math.round(lowerRgb[2] + (upperRgb[2] - lowerRgb[2]) * t);
      return '#' + rgbToHex([r, g, b]);
    }
  }

  return '#' + rgbToHex(hexToRgb(stops[stops.length - 1].hex));
};
